import React from 'react';
import unorm from 'unorm';
import SimpleIndicator from '../common/indicators/simpleIndicator';
import Label from '../common/label';
import Pie from '../common/new_graph/pie';
import { localStoreFN } from '../../store/localStorage';

// function performed to obtain the color of the pie chart according to the settings
const colorSeverity = (arr, type) => {
  // formatting process to be able to find the element in the array
  let str = type;
  str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
  str = str.toLowerCase();
  const obj = arr.find(o => o.key === type);
  return obj ? obj.color : '';
};

const translate = (arr, type, language) => {
  // formatting process to be able to find the element in the array
  let str = type;
  str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
  str = str.toLowerCase();
  const obj = arr.find(o => o.key === str);
  return obj ? obj[`${language}Name`] : '';
};

const gravityPie = props => {
  const lang = localStoreFN().getItem('lang');
  
  return (
    <div className="pie-one">
      {/* simple fault indicator */}
      <div className="item1 pie-indicator">
        <div>
          <SimpleIndicator
            value={props.fails.actual.value}
            valueFormat={{ type: 'NUMBER', format: '.0f' }}
          />
          <div className="pie-label">
            <Label label={'Fallas'} />
          </div>

          <div className="toolltip-wraper">
            {props.fails.trend === 'Better' ? (
              <div className="toolltip">
                <i className="fas fa-arrow-up fa-2x arrow" />
                <div className="bottom">
                  <h3 className="green">{`${
                    props.failsDate.failsdiferentValue
                  } punto mas con respeto al periodo anterior`}</h3>
                  <div className="pd-bottom">
                    <span>{props.language.detail_waiting_times.detailTruck.befor}</span>
                    <span>{` (${props.failsDate.previousFailStartDate} ${
                      props.language.detail_waiting_times.detailTruck.to
                    } ${props.failsDate.previousFailsEndtDate}): `}</span>
                    <span className="green">{props.failsDate.previousFailsValue}</span>
                  </div>
                  <div>
                    <span>{props.language.detail_waiting_times.detailTruck.now}</span>
                    <span>{` (${props.failsDateActual.actualFailStartDate} ${
                      props.language.detail_waiting_times.detailTruck.to
                    }${props.failsDateActual.actualFailsEndtDate}): `}</span>
                    <span className="green">{props.failsDateActual.actualFailsValue}</span>
                  </div>
                  <i />
                </div>
              </div>
            ) : props.fails.trend === 'Worse' ? (
              <div className="toolltip btn btn-primary">
                <i className="fas fa-arrow-down red fa-2x" />
                <div className="bottom">
                  <h3 className="red">{`${
                    props.failsDate.failsdiferentValue
                  } punto menos con respeto al periodo anterior`}</h3>
                  <div className="pd-bottom">
                    <span>{props.language.detail_waiting_times.detailTruck.befor}</span>
                    <span>{` (${props.failsDate.previousFailStartDate} ${
                      props.language.detail_waiting_times.detailTruck.to
                    } ${props.failsDate.previousFailsEndtDate}): `}</span>
                    <span className="green">{props.failsDate.previousFailsValue}</span>
                  </div>
                  <div>
                    <span>{props.language.detail_waiting_times.detailTruck.now}</span>
                    <span>{` (${props.failsDateActual.actualFailStartDate} al ${
                      props.failsDateActual.actualFailsEndtDate
                    }): `}</span>
                    <span className="green">{props.failsDateActual.actualFailsValue}</span>
                  </div>
                  <i />
                </div>
              </div>
            ) : props.fails.trend === 'Same' ? (
              ''
            ) : (
              <span className="arrow" />
            )}
            {props.fails.trend ? (
              props.fails.trend === 'Same' ? (
                <span className="arrow arrow-value" />
              ) : (
                <span className="arrow arrow-value">{props.fails.differenceValue}</span>
              )
            ) : (
              <span className="arrow arrow-value" />
            )}
          </div>
        </div>
      </div>

      <div className="pie-one-flex">
        <div className="pie-gravity">
          {/*pie gravity container*/}
          <div className="pie gravity-one">
            {/*pie element*/}
            <Pie
              size={60}
              data={props.item ? props.item.severityFails : []}
              width={130}
              height={160}
              animation={false}
              translate
              name="severityType"
              value="value"
              colors={props.obj.form.severityFailsColor}
              language={lang}
            />
          </div>
        </div>
        <div className="pie-label-gravity">
          {/*pie gravity labels*/}
          <h4>Gravedad</h4>
          <ul className="list-pie">
            {props.severityFails.map(item => {
              return (
                <li key={item.severityType}>
                  <span
                    style={{
                      background: colorSeverity(props.obj.form.severityFailsColor, item.severityType),
                      height: 10,
                      width: 10
                    }}
                  />
                  {translate(
                    props.obj.form.severityFailsColor,
                    item.severityType,
                    props.languageFormat
                  )}{' '}
                  {`(${item.value}%)`}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  )
};

export default gravityPie;



// WEBPACK FOOTER //
// ./source/client/components/detail_truck/gravityPie.jsx